
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","fill":"none","xmlns":"http://www.w3.org/2000/svg","preserveAspectRatio":"xMidYMid meet"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M25.004 6.5c5.8.003 10.5 4.706 10.496 10.503 0 4.447-2.805 8.413-7 9.898-.33.117-.575.39-.658.7l-.023.117-.011.162v.659A2.808 2.808 0 0125 31.345a2.81 2.81 0 01-2.775-2.388l-.022-.174-.01-.245v-.66a6.656 6.656 0 013.88-6.047l.24-.104.314-.121a4.884 4.884 0 00-1.626-9.492 4.882 4.882 0 00-4.861 4.382l-.017.218-.008.282a2.808 2.808 0 11-5.615 0c0-5.704 4.551-10.346 10.22-10.493l.284-.004zm.265 26.93l-.251-.01-.269.009-.197.019a3.77 3.77 0 10.716-.018zm-.467.998l.197-.007.217.007.17.018a2.769 2.769 0 012.383 2.744 2.77 2.77 0 11-2.967-2.762zM15.5 16.998c0-5.248 4.256-9.501 9.504-9.498l.27.004c5.123.146 9.23 4.344 9.226 9.498a9.502 9.502 0 01-6.333 8.956 2.039 2.039 0 00-1.343 1.666l-.015.224-.001.69-.006.149a1.808 1.808 0 01-3.601.026l-.01-.198.001-.636.006-.244a5.654 5.654 0 013.485-4.978l.522-.2a5.884 5.884 0 003.68-5.456A5.884 5.884 0 0025 11.115a5.883 5.883 0 00-5.877 5.56l-.014.46a1.808 1.808 0 01-3.61-.137z","fill":"#8B96B8"}})])
          )
        }
      }
    